import EmblaCarousel, {EmblaCarouselType} from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import * as React from 'react';
import {fetchReferences, ReferencePartner, ReferenceSite} from '../../api/references';
import {Container} from '../grid/container';
import './style.scss';
import {Translation} from '../../lang';

export class DesignComponent extends React.Component<any, any> {
    public embla: EmblaCarouselType | null = null;
    public carouselRef: HTMLElement | null = null;
    private mounted = false;

    public state: any = {
        sites: [],
        partners: [],
        loading: true,
        error: false
    };

    componentDidMount(): void {
        this.mounted = true;

        fetchReferences()
            .then((data) => {
                if (!this.mounted) {
                    return;
                }

                this.setState({sites: data.sites, partners: data.partners, loading: false});
            })
            .catch(() => {
                if (!this.mounted) {
                    return;
                }

                this.setState({loading: false, error: true});
            });
    }

    componentWillUnmount(): void {
        this.mounted = false;
        this.destroyCarousel();
    }

    /**
     * A carousel csak akkor létezik a DOM-ban, ha már megjöttek a partnerek, ezért az
     * inicializálás a ref-callbackhez van kötve, nem a componentDidMounthoz.
     */
    private setCarouselRef(node: HTMLElement | null) {
        if (node === this.carouselRef) {
            return;
        }

        this.carouselRef = node;
        this.destroyCarousel();

        if (!node) {
            return;
        }

        // A látható logók számát a .partner-slide flex-basisa adja (1 / 3 / 6 a
        // töréspontokon), az Embla csak a görgetést végzi.
        this.embla = EmblaCarousel(node, {
            loop: true,
            align: 'start',
            duration: 45
        }, [
            Autoplay({
                delay: 3000,
                stopOnInteraction: false,
                stopOnMouseEnter: false
            })
        ]);
    }

    private destroyCarousel() {
        if (this.embla) {
            this.embla.destroy();
            this.embla = null;
        }
    }

    render() {
        const {sites, partners, loading, error} = this.state;

        return <Container className="designComponent">
            <div
                className="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 MS text-white text-center content-height">

                <h1 className="fw-bold fst-italic">{Translation.get('design.title')}</h1>
                <p className="fst-italic" style={{whiteSpace: 'pre-wrap'}}>
                    {Translation.get('design.description')}
                </p>

                <br/>
                <br/>
                {partners.length > 0 && <div className={'partner-carousel'}
                                             ref={(ref: any) => { this.setCarouselRef(ref); }}>
                    <div className="partner-track">
                        {partners.map((partner: ReferencePartner, index: number) => {
                            // A title a CMS-ből érkezik; a korábbi kimenetekben még nincs meg,
                            // ilyenkor a name marad az alt-szöveg.
                            const label = Translation.pick(partner.title, partner.name);

                            return <div key={index} className={'partner-slide'}>
                                <div className={'partner-logo'}>
                                    <img src={partner.logo} alt={label} title={label}/>
                                </div>
                            </div>;
                        })}
                    </div>
                </div>}
            </div>
            <div className="container-fluid">

                <div className="col-12">
                    <div className="col-12 col-sm-10 offset-sm-1">

                        {loading && <p className="MS text-white text-center fst-italic referencesStatus">
                            {Translation.get('misc.loading.title')}
                        </p>}

                        {error && <p className="MS text-white text-center fst-italic referencesStatus">
                            {Translation.get('misc.load_error.title')}
                        </p>}

                        {sites.map((site: ReferenceSite, index: number) => <div key={site.key || index}
                                                                                className="siteWrapper animated fadeInUp">

                            <div className={`siteItem ${(index % 2) ? 'reverse' : ''}`}>
                                <div className={`imageWrapper ${(index % 2) ? '' : 'perspective-reverse'}`}>
                                    <img src={site.image} alt={site.url}/>
                                    <div className="overlay">
                                        <a href={site.url} target="_blank"
                                           className="visitSite text-uppercase MS">{Translation.get('misc.view_button.title')}</a>
                                    </div>
                                </div>
                                <div className="descriptionWrapper">
                                    <h3 className="MS text-white fst-italic fw-bold">{Translation.pick(site.title)}</h3>
                                    <p className="MS text-white fst-italic">{Translation.pick(site.description)}</p>
                                </div>
                            </div>

                        </div>)}
                    </div>
                </div>

            </div>

        </Container>;
    }
}
